import { render, staticRenderFns } from "./StaticCourseList.vue?vue&type=template&id=e40be416&scoped=true"
import script from "./StaticCourseList.vue?vue&type=script&lang=js"
export * from "./StaticCourseList.vue?vue&type=script&lang=js"
import style0 from "./StaticCourseList.vue?vue&type=style&index=0&id=e40be416&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40be416",
  null
  
)

export default component.exports